import { componentsThemeMap } from '../../componentsThemeMap.js';
import { ANALYTICS_KEY } from '../../constants.js';
import { SectionComponentLayout } from '../../layout/SectionComponentLayout.js';
import { CarouselSlide } from '../../ui/Carousel/CarouselSlide.js';
import '../../ui/Div/index.js';
import { LinkButton } from '../../ui/Link/LinkButton.js';
import '../../ui/media/index.js';
import '../../ui/RichText/index.js';
import { Text } from '../../ui/Text.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
import { Media } from '../../ui/media/Lazymedia.js';
import { RichText } from '../../ui/RichText/RichText.js';
const CAROUSEL_CARD_IMAGE_HEIGHTS = {
  sm: 178,
  md: 306,
  lg: 480
};
function HighlightCardsCarouselCard({
  mediaUrl,
  mediaAlt = 'Carousel Slide Image',
  headline,
  description,
  ctaLabel,
  ctaUrl: ctaUrl,
  style = 'default'
}) {
  const _componentsThemeMap$s = componentsThemeMap[style],
    foreground = _componentsThemeMap$s.foreground,
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary,
    background = _componentsThemeMap$s.background;
  return /*#__PURE__*/jsx(CarouselSlide, {
    css: {
      background
    },
    children: /*#__PURE__*/jsx(SectionComponentLayout, {
      hasSpacingHorizontal: true,
      background: background,
      children: /*#__PURE__*/jsxs(Div, {
        flexDirection: "column",
        width: "100%",
        children: [/*#__PURE__*/jsx(Media, {
          mediaType: "image",
          src: mediaUrl,
          alt: mediaAlt,
          imageFit: "cover",
          height: CAROUSEL_CARD_IMAGE_HEIGHTS,
          loading: "eager",
          priority: true
        }), /*#__PURE__*/jsxs(Div, {
          flexDirection: "column",
          alignItems: "center",
          css: {
            textAlign: 'center'
          },
          spacingTop: {
            sm: 7,
            lg: 11
          },
          children: [/*#__PURE__*/jsx(Text, {
            variant: {
              sm: 'title2',
              lg: 'display2'
            },
            as: "h1",
            color: foreground,
            children: headline
          }), description && /*#__PURE__*/jsx(RichText, {
            content: description,
            color: foregroundSecondary
          }), ctaLabel && ctaUrl && /*#__PURE__*/jsx(Div, {
            spacingTop: {
              sm: 3,
              md: 6
            },
            children: /*#__PURE__*/jsx(LinkButton, {
              href: ctaUrl,
              "data-qa": ANALYTICS_KEY.CTAButtonsFirst,
              variant: background === 'primary' ? 'secondary' : 'primary',
              children: ctaLabel
            })
          })]
        })]
      })
    })
  });
}
export { CAROUSEL_CARD_IMAGE_HEIGHTS, HighlightCardsCarouselCard };
//# sourceMappingURL=HighlightCardsCarouselCard.js.map
